import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { getUserByAuth0Id2 } from '../../../api/auth0Api';
import { useParams } from 'react-router-dom';

const useGetUserByAuth0Id = () => {
  const { auth0Id } = useParams();
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    ['user', auth0Id],
    async () => {
      const token = await getAccessTokenSilently();
      return await getUserByAuth0Id2(token, auth0Id);
    },
    {
      enabled: !!auth0Id,
    },
  );
};

export default useGetUserByAuth0Id;
